export default {
  data () {
    return {
      // 加载状态
      m_loading: false,
      m_loadText: '正在加载中',
      m_finished: false,
      m_finishedText: '已全部加载完成',
      // 是否在初始化时立即执行滚动位置检查
      m_immediateCheck: false,
      m_page: {
        curr: 1,
        limit: 10
      }
    }
  },
  methods: {
    /**
     * 数据开始请求时
     */
    mRequest (str = '正在加载中') {
      // this.loadText = str
      this.m_loadText = str
      this.m_loading = true
    },
    /**
     * 数据加载完成后调这个方法
     */
    mSuccess () {
      this.m_loading = false
      this.m_page.curr++
    },
    /**
     * 数据全部加载完成后
     * @param {string} finishedText 显示文案
     */
    mEnd (finishedText = '没有数据了') {
      this.m_loading = false
      this.m_finished = true
      this.m_finishedText = finishedText
    },
    /**
     * 重置
     */
    mReset () {
      this.m_loading = false
      this.m_page.curr = 1
      this.m_page.limit = 10
      this.m_loading = false
      this.m_finished = false
    },
    /**
     * @description 上拉加载
     */
    mHandlePullUpLoadMore () {
      if (!this.m_finished) {
        if (this.loadData && typeof this.loadData === 'function') {
          this.loadData()
        }
      }
    }
  }
}
